import React from 'react';
import ReactDOM from 'react-dom';
import { inject } from '@vercel/analytics';
import './index.css';

import App from './components/App';

inject();

ReactDOM.render(
    <App />,
    document.querySelector('#root')
);


